import { TAnswerState } from '../../../../containers/FormContainer/types/internal';

export const listMapper = (answerState: TAnswerState) => {
  const value = Array.isArray(answerState.value) ? answerState.value : [answerState.value];

  return { [answerState.answerField]: value };
};
